// pages/LiveChatPage.js

import React from 'react';
import ConversationList from '../components/chat/ConversationList';
import AdminChatView from '../components/chat/AdminChatView';

const LiveChatPage = () => {
  return (
    <div className="h-[calc(100vh-theme(space.24))] flex flex-col">
     
      <div className="flex-grow grid grid-cols-1 md:grid-cols-4 lg:grid-cols-3 gap-0 overflow-hidden">
        <div className="md:col-span-1 lg:col-span-1 border-r border-gray-200 h-full overflow-y-auto">
          <ConversationList />
        </div>
        <div className="md:col-span-3 lg:col-span-2 h-full flex flex-col overflow-hidden">
          <AdminChatView />
        </div>
      </div>
    </div>
  );
};

export default LiveChatPage;
